<i18n
  src="@/locales/views/agro_exporter/finances/query_container_incomes/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/export_invoice.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-file-invoice-dollar"></i
      ><span class="space-icon"></span>
      {{ $t("labels.export_invoices_title") }}
    </h1>

    <div class="mt-6 flex flex-row justify-between">
      <div class="panel-plain-label space-x-4">
        <badge-default
          :label="
            export_invoices.length +
            ' ' +
            $t('labels.total_number_export_invoices')
          "
        />
        <badge-default
          :label="
            export_invoices_paid +
            ' ' +
            $t('labels.total_number_export_invoices_paid')
          "
        />
      </div>
      <button type="button" @click.prevent="downloadReport()" class="btn-white">
        <i
          :class="[
            'fa-solid',
            downloading ? 'fa-sync fa-spin' : 'fa-file-excel'
          ]"
        ></i
        ><span class="space-icon"></span
        >{{ $t("labels.download_button") }}
      </button>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="width: 100%; height: 650px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="export_invoices_custom"
      >
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import Requester from "@/views/agro_exporter/requesters/finances/query_container_incomes/show_process.js";

export default {
  name: "AEFinancesQueryContainerIncomesShowProcessExportInvoices",
  components: { AgGridVue },
  data() {
    return {
      downloading: false,
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true
      },
      columnDefs: [
        {
          headerName: this.$t("model.export_invoice.invoice_date"),
          field: "invoice_date",
          filter: true
        },
        {
          headerName: this.$t("model.export_invoice.invoice_code"),
          field: "invoice_code",
          filter: true,
          cellRendererSelector: params => {
            const agro_exporter_id = this.agro_exporter_id;
            const agro_exporter_process_id = this.agro_exporter_process_id;
            const GoToLink = {
              template: `<span @click.prevent="this.showExportInvoice()" class="link">${params.value}</span>`,
              methods: {
                showExportInvoice: function () {
                  this.$router.push({
                    name: this.routeName("show_export_invoice"),
                    params: {
                      agro_exporter_id: agro_exporter_id,
                      agro_exporter_process_id: agro_exporter_process_id,
                      export_invoice_id: params.data.id,
                      container_id: params.data.container_id
                    }
                  });
                }
              }
            };
            return {
              component: GoToLink
            };
          }
        },
        {
          headerName: this.$t("model.container.week"),
          field: "container.week",
          filter: "agNumberColumnFilter",
          maxWidth: 150
        },
        {
          headerName: this.$t("model.export_invoice.container"),
          field: "container.container_code",
          filter: true
        },
        {
          headerName: this.$t("model.export_invoice.amount"),
          field: "amount",
          filter: "agNumberColumnFilter",
          cellRenderer: params => {
            return this.currencyMoney(
              params.value,
              params.data.currency.symbol
            );
          }
        },
        {
          headerName: this.$t("model.export_invoice.amount_paid"),
          field: "amount_paid",
          filter: "agNumberColumnFilter",
          cellRenderer: params => {
            return this.currencyMoney(
              params.value,
              params.data.currency.symbol
            );
          }
        },
        {
          headerName: this.$t("model.export_invoice.paid"),
          field: "paid_label",
          filter: true,
          maxWidth: 150,
          cellRendererSelector: params => {
            const YesNoLabel = {
              template: `<yes-no-label :value="${params.data.paid}" />`
            };
            return {
              component: YesNoLabel
            };
          }
        }
      ]
    };
  },
  props: {
    agro_exporter_id: {},
    agro_exporter_process_id: {},
    export_invoices: {
      type: Array
    }
  },
  computed: {
    export_invoices_paid: function () {
      return this.export_invoices.filter(export_invoice => export_invoice.paid)
        .length;
    },
    export_invoices_custom: function () {
      return this.export_invoices.map(export_invoice => {
        return {
          ...export_invoice,
          invoice_date: this.dateFormatter(export_invoice.invoice_date),
          paid_label: export_invoice.paid ? ["yes", "si"] : ["no"]
        };
      });
    }
  },
  methods: {
    downloadReport: async function() {
      this.downloading = true;
      try {
        var response = await Requester.downloadRepXlsx(
          this.agro_exporter_id,
          this.agro_exporter_process_id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "Facturas_y_pagos.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading = false;
    },
    sizeToFit() {
      //this.gridApi.sizeColumnsToFit({
      //  defaultMinWidth: 200
      //});

      this.gridApi.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    }
  }
};
</script>
